export const API_BASE =
  process.env.REACT_APP_API_BASE ?? "http://localhost:3001";
export const DEV_MODE = process.env.REACT_APP_DEV_MODE === "true";
